<template>
    <div class="col-12">
        <template v-if="divisions">
            <label v-bind:for="selectorId" class="control-label">{{ resource('TemplateShare_SelectedDivisionId_Label') }}</label>

            <div class="row form-group">
                <div class="col-8">
                    <division-dropdown
                            v-model="selectedDivisionId"
                            v-bind:exclude-own-division="true"
                            v-bind:division-list="divisions"
                            v-bind:id="selectorId"
                    ></division-dropdown>
                </div>
                <div class="col-4 text-right">
                    <button class="btn btn-primary" @click="promptShareRecord">{{ resource('TemplateShare_ShareWithDivision_Button_Text') }}</button>
                </div>
            </div>
        </template>
        
        <hr />
        
        <div class="row">
            <div class="col-8">
                <label class="control-label">{{ resource('TemplateShare_SharedWith_Divisions_Label') }}</label>
            </div>
            
            <div class="col-4">
                <label class="control-label">{{ resource('TemplateShare_SharedWith_Published_Label') }}</label>
            </div>
        </div>
        
        <div class="row" 
             v-for="sharedTemplate in divisionSharedTemplates" 
             v-bind:key="sharedTemplate.divisionId"
        >
            <div class="col-8">
                {{ sharedTemplate.name }}
            </div>
            <div class="col-4">
                <template v-if="sharedTemplate.isPublished">
                    <i class="fas fa-lg fa-check"></i>
                </template>
            </div>
            
            <div class="col-12">
                <hr class="my-3" />
            </div>
        </div>
    </div>
</template>

<script>
    import templateManagerApi from '../../../Api/template-manager';
    import divisionApi from '../../../Api/divisions';
    
    import {guid} from "../../../Util/guid";
    import {promptV2} from "../../../Util/prompt";

    import growlApi from '../../../Util/growler';
    
    import resourceMixin from '../../../Util/Mixins/resources';
    
    import DivisionDropdown from '../../../Components/Util/DivisionDropdown.vue';
    
    let listDivisionsProm;
    
    export default {
        name: "template-share",
        components: {
            DivisionDropdown
        },
        mixins: [resourceMixin],
        beforeCreate(){
            const vm = this;

            //Obtaining our divisions is template agnostic
            //Therefor we can execute it within our beforeCreate(...) state
            //Cache our divisions promise for re-use
            (listDivisionsProm || (listDivisionsProm = divisionApi.getDivisionsList({ includeDisabled: true })))
                .then(
                    divisions => { vm.divisions = divisions; },
                    growlApi.bootstrapDanger
                );
        },
        created(){
            const vm = this;

            vm.id = guid();
            
            templateManagerApi.getSharedTemplates(vm.templateId)
                .then(
                    sharedTemplates => vm.sharedTemplates = sharedTemplates,
                    growlApi.bootstrapDanger
                );
        },
        methods: {
            promptShareRecord(){
                const vm = this;
                
                promptV2(vm.resource('TemplateShare_ShareRecordPrompt_Title'), vm.resource('TemplateShare_ShareRecordPrompt_Body'))
                    .then(_ => { 
                        templateManagerApi.shareTemplate(vm.templateId, vm.selectedDivisionId).then(sharedTemplate => {
                            vm.sharedTemplates.push(sharedTemplate);
                        }, growlApi.bootstrapDanger);
                    },
                    () => { /*Do nothing */ }
                );
            }
        },
        computed: {
            divisionSharedTemplates(){
                const vm = this;

                //We'll have to wait for our promises to resolve prior to performing our mapping
                if(!vm.sharedTemplates || !vm.divisions){
                    return [];
                }

                //Join our sharedTemplates with our divisions
                const divisionSharedTemplates = vm.sharedTemplates.map(st => {
                    const division = vm.divisions.find(d => d.Id === st.id);

                    return {
                        name: division.Name,
                        // isPublished: true
                        isPublished: st.isPublished
                    }
                });

                //Sort by division name
                divisionSharedTemplates.sort((left, right) => {
                    if(left.name > right.name) return 1;
                    if(right.name > left.name) return -1;

                    return 0;
                });

                return divisionSharedTemplates;
            },
            selectorId(){
                const vm = this;
                return `division-selector-${vm.id}`;
            }
        },
        data() {
            return {
                divisions: null,
                selectedDivisionId: null,
                sharedTemplates: null,
                id: null
            };
        },
        props: {
            templateId: {
                type: String,
                required: true
            }
        }
    };
</script>

<style scoped src="../Style/template-share.scss" lang="scss">

</style>
